import { SelectionModel } from '@angular/cdk/collections';
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Inject,
    ViewChild,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { take } from 'rxjs/operators';
import { Document } from 'src/app/acl-data/document/document.dto';
import { DocumentService } from 'src/app/acl-data/document/document.service';
import { FolderService } from 'src/app/acl-data/folder/folder.service';
import { I1FilenetServices } from 'src/app/acl-data/i1-filenet-services.service';

import { SearchResultDTO } from '../search-result.dto';
import { MatTabGroup } from '@angular/material/tabs';
import { MatSnackBar } from '@angular/material/snack-bar';

export interface ILinkDocumentDialogData {
    folderID: string;
    objectStore: string;
    excludedIDs: string[];
}

@Component({
    templateUrl: './link-document-dialog.component.html',
    styleUrls: ['./link-document-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinkDocumentDialogComponent {
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    @ViewChild('tabs') tabs: MatTabGroup;

    selected = [];
    selectedTab = 0;

    documentIds: SearchResultDTO[] = [];
    loading$ = new BehaviorSubject(false);
    resultsExceeded = false;
    errorSearching = false;

    fullTextResults = false;

    dataSource;
    displayedColumns: string[] = [
        'select',
        'ContractDeletedDate',
        'Name',
        'ContractIdentifier',
        'ContractStartDate',
        'ContractEndDate',
        'ContractDateOfLastSignature',
        'ContractReviewDeadlineDate',
        'ContractStatus',
        'DateCreated',
    ];

    onNoClick(): void {
        this.dialogRef.close();
    }

    constructor(
        public dialogRef: MatDialogRef<LinkDocumentDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ILinkDocumentDialogData,
        private i1FilenetService: I1FilenetServices,
        private cdr: ChangeDetectorRef,
        public snakbar: MatSnackBar
    ) {}

    resultSelect(input) {
        this.selected = input;
    }

    search = input => {
        console.log('Searching: ', input);
        this.loading$.next(true);
        this.loading$.next(true);

        this.i1FilenetService
            .searchContract(this.data.objectStore, input)
            .pipe(take(1))
            .subscribe(
                v => {
                    this.resultsExceeded = v.status === 250;

                    this.fullTextResults =
                        input.textFilter && input.textFilter.length > 0;

                    this.documentIds = v.body.filter(
                        v => this.data.excludedIDs.indexOf(v.id) === -1
                    );
                    this.cdr.detectChanges();
                    this.loading$.next(false);
                    this.selectedTab = 1;
                    this.tabs.selectedIndex = 1;
                },
                error => {
                    this.loading$.next(false);
                    this.errorSearching = true;
                    this.snakbar.open(
                        'The server was unable to process your search request, please try different filters or contact your system administrator',
                        'OK'
                    );
                }
            );
    };
}
